import { Children } from 'react';

const Iterator=({render,of})=>Children.toArray(of.map((item,index)=>render(item,index)));

export { Iterator };
//# sourceMappingURL=iterator.js.map
